import script from "./StatsNetworkComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./StatsNetworkComponent.vue?vue&type=script&setup=true&lang=js"

import "./StatsNetworkComponent.vue?vue&type=style&index=0&id=cb644d5c&scoped=true&lang=css"

import exportComponent from "D:\\vsts-agent\\_work\\53\\s\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cb644d5c"]])

export default __exports__